import { gql } from "lib/apolloClient";

export const configurationViewFragment = {
  configurationView: gql`
    fragment configurationViewItem on ConfigurationView {
      id
      labelKey
      metadata
      uiType
      viewType
      displaySequence
      parentView {
        id
        labelKey
      }
      configuration {
        id
        configuration
        configurationGroup
      }
      controlParameter {
        id
      }
    }
  `,
};

export const gradesModuleSettingsFragment = {
  gradesModuleSettings: gql`
    fragment gradesModuleSettings on Organization {
      grades(filters: $gradeFilters) {
        id
        name
        __typename
      }
      __typename
    }
  `,
};

export const getConfigurationV2SettingFragment = {
  getConfigurationV2SettingItem: gql`
    fragment configurationV2SettingItem on CourseConfigurations {
      configurationId
      value
      platformCategorizedValues {
        default
        staff
        parent
        student
        __typename
      }
      __typename
    }
  `,
};

export const getCourseModuleSettingFragment = {
  getCourseModuleSetting: gql`
    fragment courseModuleSetting on Organization {
      courses(
        filters: $courseFilters
        orderBy: $orderBy
        orderByDirection: $orderByDirection
      ) {
        edges {
          node {
            id
            title
            primaryGrade {
              id
              __typename
            }
            subjects {
              id
              name
              __typename
              subjectGroup {
                id
                name
                type
                __typename
              }
            }
            configurations(filters: $configurationFilters)
              @include(if: $includeConfigs) {
              ...configurationV2SettingItem
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    ${getConfigurationV2SettingFragment.getConfigurationV2SettingItem}
  `,
};

export const curriculumProgramsItemFragment = {
  curriculumProgramsItem: gql`
    fragment curriculumProgramsItem on Organization {
      id
      curriculumPrograms {
        id
        label
        acronym
        terms {
          totalCount
          __typename
        }
        ... on IbMypCurriculumProgram {
          moduleSettingCourseCusomTags(filters: $customCourseTagsFilter)
        }
        ... on IbPypCurriculumProgram {
          moduleSettingCourseCusomTags(filters: $customCourseTagsFilter)
        }
        ... on UBDCurriculumProgram {
          moduleSettingCourseCusomTags(filters: $customCourseTagsFilter)
        }
        ... on IbDpCurriculumProgram {
          moduleSettingCourseCusomTags(filters: $customCourseTagsFilter)
        }
        __typename
      }
      __typename
    }
  `,
};
